/* oxlint-disable import/no-mutable-exports */
/* oxlint-disable global-require */
/* oxlint-disable prefer-const */
import { merge } from 'lodash';

import { envBaseUrls } from './constants';

type Config = Readonly<{
  launchdarkly: {
    baseUrl: string;
    streamUrl: string;
    eventsUrl: string;
    clientId: string;
    environment: string; // environment key on catfood
    project?: string;
  };
  gonfalon: {
    host: string; // private host
    ghostUrl?: string; // private host with SSL and subdomain under app
    publicUrl: string; // main URL
    localPrivateAuth?: boolean; // true when running Gonfalon locally to allow private API auth
  };
  honeycomb: {
    dataset?: string; // honeycomb dataset name
  };
  provisioning: {
    host: string;
    sfdcBaseUrl: string;
  };
  slack: {
    webhookUrl?: string;
  };
  datadog: {
    applicationId?: string;
    clientToken?: string;
    site?: string;
  };
  newrelic: {
    licenseKey?: string;
    applicationID?: string;
    accountID?: string;
    agentID?: string;
    trustKey?: string;
    beacon?: string;
  };
  help: {
    troubleshootingURL?: string;
    slackURL?: string;
    slackChannelName?: string;
  };
}>;

let config: Config;
let override: Partial<Config> = {};
const local: Config = require('../vitalstatistix.local.json');

if (process.env.VITALSTATISTIX_MODE === 'production') {
  override = require('../vitalstatistix.prod.json');
} else if (process.env.VITALSTATISTIX_MODE === 'staging') {
  override = require('../vitalstatistix.stg.json');
} else if (process.env.VITALSTATISTIX_MODE === 'federal_staging') {
  override = require('../vitalstatistix.federal_staging.json');
} else if (process.env.VITALSTATISTIX_MODE === 'federal_production') {
  override = require('../vitalstatistix.federal_production.json');
} else if (process.env.VITALSTATISTIX_MODE === 'catamorphic') {
  override = require('../vitalstatistix.catamorphic.json');
} else if (process.env.VITALSTATISTIX_MODE === 'eu_production') {
  override = require('../vitalstatistix.eu_production.json');
} else {
  try {
    // Optional local override for developers; not present in CI by default
    // oxlint-disable-next-line import/no-unresolved
    override = require('../vitalstatistix.override.json');
  } catch {
    override = {};
  }
}

config = merge({}, local, override);

export default config;

export const baseUrl = () => {
  if (process.env.VITALSTATISTIX_MODE === 'production') {
    return envBaseUrls.production;
  }
  if (process.env.VITALSTATISTIX_MODE === 'staging') {
    return envBaseUrls.staging;
  }
  if (process.env.VITALSTATISTIX_MODE === 'federal_staging') {
    return envBaseUrls.federalStaging;
  }
  if (process.env.VITALSTATISTIX_MODE === 'federal_production') {
    return envBaseUrls.federalProduction;
  }
  if (process.env.VITALSTATISTIX_MODE === 'catamorphic') {
    return envBaseUrls.catamorphic;
  }
  if (process.env.VITALSTATISTIX_MODE === 'eu_production') {
    return envBaseUrls.euProduction;
  }
  return envBaseUrls.localHost;
};
